import { useRef, useState, type ReactNode } from 'react';
import { ActionButton, ActionTextarea } from '../../../parts/index.js';
import { ApiError } from '../../../api.js';
import { NotSaved, Refused } from './DrawingStates.js';
import '../drawing/drawing.css';
export function Change({ label, sentence, children, ready = true, onSave, onSaved, onCancel, onConflict, reasonPlaceholder = 'Reason' }: {
  label: string; reasonPlaceholder?: string; sentence?: string; children?: ReactNode; ready?: boolean;
  onSave: (reason: string) => Promise<unknown>; onSaved: () => void; onCancel: () => void; onConflict: () => void;
}) {
  const [reason, setReason] = useState(''); const [asked, setAsked] = useState(false); const [busy, setBusy] = useState(false); const [error, setError] = useState<unknown>();
  const inflight = useRef(false);
  async function save() {
    // Pressed with no reason: nothing is written, and the box says why (the drawing shows no line until then).
    if (!reason.trim()) { setAsked(true); return; }
    if (inflight.current || !ready) return;
    inflight.current = true; setBusy(true); setError(undefined);
    try { await onSave(reason.trim()); onSaved(); }
    catch (e) {
      // A bare 404 means the server no longer offers this change (pause switched off): close and reload, which hides it.
      if (e instanceof ApiError && e.status === 404 && e.message === 'not found') { onCancel(); onConflict(); return; }
      setError(e); if (e instanceof ApiError && e.status === 409) onConflict();
    }
    finally { inflight.current = false; setBusy(false); }
  }
  return <div className="confirm">
    {sentence && <p className="lede">{sentence}</p>}{children}
    <ActionTextarea aria-label="Reason" placeholder={reasonPlaceholder} className="field typed-reason" required disabled={busy} value={reason} onChange={e => setReason(e.target.value)} />
    <div className="opts">
      <ActionButton className="opt lead" disabled={busy || !ready} onClick={() => void save()}>{label}</ActionButton>
      {asked && !reason.trim() && <span className="note" role="alert">Give a reason first</span>}
      <ActionButton className="textbtn" disabled={busy} onClick={onCancel}>Cancel</ActionButton>
    </div>
    {error != null && (error instanceof ApiError && [403, 404, 409, 422].includes(error.status)
      ? <Refused words={error.message} /> : <NotSaved reason={error instanceof Error ? error.message : String(error)} onRetry={() => void save()} />)}
  </div>;
}
